import { render, staticRenderFns } from "./SectionNumbers.vue?vue&type=template&id=52593f8b"
import script from "./SectionNumbers.vue?vue&type=script&lang=js"
export * from "./SectionNumbers.vue?vue&type=script&lang=js"
import style0 from "./SectionNumbers.vue?vue&type=style&index=0&id=52593f8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports